import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Form, Input, Submit, SelectAutoComplete } from "../Form";
import { Actions } from "../Modal";
import { createAccount, editAccount } from "../../features/accounts/accountSlice";

const properties = { id: '', nombre: '', usuario: '', area: '', idArea: '' }

const CreateForm = () => {
    const { id, openModalEdit } = useSelector(state => state.modal);
    const { areas, teachers, accounts } = useSelector(state => state.accounts)
    const [showPassword, setShowPassword] = useState(false);
    const handleShowPassword = () => setShowPassword(!showPassword);
    const [showConfirm, setShowConfirm] = useState(false);
    const handleShowConfirm = () => setShowConfirm(!showConfirm);
    const dispatch = useDispatch()
    const methods = useForm({ shouldUnregister: true })
    const data = openModalEdit ? accounts.find(el => el.id === id) : properties;

    const title = openModalEdit ? `Cambiar usuario` : 'Nuevo usuario';
    const onSubmit = values => {
        if(values.password !== values.confirm) return methods.setError('confirm', { type: 'error', message: 'Las contraseñas deben ser iguales'})
        else if(openModalEdit) dispatch(editAccount({ id, values, setError: methods.setError })) 
        else dispatch(createAccount({values, setError: methods.setError}))
    }
    return(
        <Actions title={title}>
            <Form methods={methods} onSubmit={onSubmit}>
                { openModalEdit && <Typography variant="body2">Usuario: <b>{data.usuario} - {data.nombre}</b> <br /> Área: <b>{data.area} </b></Typography> }
                <Grid container spacing={2}>
                    <SelectAutoComplete name={'user'} label="Selecciona Profesor" options={teachers} />
                    {!openModalEdit ? <SelectAutoComplete name={'idArea'} label="Selecciona Área" options={areas} /> : null }
                    <Input type={ showPassword ? 'text' : 'password' } name={'password'} label="Contraseña" min={8} max={20} handleShowPassword={handleShowPassword} size={6} />
                    <Input type={ showConfirm ? 'text' : 'password' } name={'confirm'} label="Escribe nuevamente la contraseña" min={8} max={20} handleShowPassword={handleShowConfirm} size={6} />
                    <Submit title={openModalEdit ? 'Guardar Cambios' : 'Registrar'} />
                </Grid>
            </Form>
        </Actions>
    )
}

export default CreateForm;